export default "__VITE_ASSET__Cv1_FwzS__"